import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useSelector } from "react-redux";
import { paginate } from "../../utils/paginate";
import Pagination from "../common/Pagination";
import { Link } from "react-router-dom";
import ScrollToTop from "./../Layouts/ScrollToTop";
//import { useSelector } from "react-redux";
//import { paginate } from "../../utils/paginate";
//import Course from "./Course";
const Archive = () => {
    const [search, setSearch] = useState("")
    const [coursesList, setCoursesList] = useState([])
    const [perPage, setPerpage] = useState(9);
    const [currentPage, setCurrentPage] = useState(1);
    const courses = useSelector(state => state.courses);
    useEffect(() => setCoursesList(courses), [courses])

    const filterCourses = coursesList.filter(course => course.title.includes(search));


    const handlePageChange = page => {
        setCurrentPage(page);
    }


    const indexCourses = paginate(filterCourses, currentPage, perPage);



    return (
        <ScrollToTop>
            <section className="term-categories">
                <Helmet>
                    <title>
                        ماه کورس | همه ی دوره ها
                    </title>
                </Helmet>
                <div className="row top-bar">
                    <header>
                        <h1>
                            {" "}
                            دوره های <span> برنامه نویسی وب </span>{" "}
                        </h1>{" "}
                        <span> 15 دوره </span>
                    </header>

                    <div className="row">
                        <div className="col-md-4 col-sm-12 col-xs-12 pull-right">
                            <form action="" method="">
                                <div className="input">
                                    <input
                                        onChange={e => setSearch(e.target.value)}
                                        type="text"
                                        name=""
                                        placeholder="موضوع مورد نظر ..."
                                    />
                                    <button>
                                        <i className="zmdi zmdi-search"></i>
                                    </button>
                                </div>
                            </form>
                        </div>


                    </div>
                </div>

                <div className="row">

                    <div className="">
                        <section className="terms-items">
                            <div className="row">


                                {
                                    indexCourses?.map(course => {
                                        return (
                                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 term-col" key={course._id} >
                                                <article>
                                                    <Link to={`/course/${course._id}`} className="img-layer">
                                                        <img
                                                            style={{ height: "180px" }}
                                                            src={`https://toplearnapi.ghorbany.dev/${course.imageUrl}`} />
                                                    </Link>
                                                    <h2>
                                                        <Link href="">
                                                            {course.title}
                                                        </Link>
                                                    </h2>
                                                    <span> رایگان </span>
                                                    <i>1:52:32</i>
                                                </article>
                                            </div>
                                        )
                                    })
                                }


                            </div>

                            <Pagination
                                totalCourse={filterCourses.length}
                                currentPage={currentPage}
                                perPage={perPage} onPageChange={handlePageChange} />
                        </section>
                    </div>
                </div>
            </section>
        </ScrollToTop>
    );
};

export default Archive;
